/* eslint-disable */
import {
  asyncRouterMap
} from '@/router'
import _ from 'lodash'
import store from '../../store';

const permission = {
  state: {
    routers: [],
    addRouters: [],
  },
  mutations: {
    SET_VIEW_MENU: (state) => {
      /**
       * LEFT 메뉴를 저장
       */
      let checkVendor = store.getters.user.vendorClassCd === 'VCC0000003'
      let viewRouters = [];
      _.forEach(asyncRouterMap, item => {
        let vendorhidden = item.checkVendor && !checkVendor ? true : false;
        if (_.findIndex(viewRouters, { name: item.name }) === -1 && !item.hidden && !vendorhidden) {
          viewRouters.push({
            href: item.path,
            icon: item.icon,
            name: item.name,
            title: item.title,
            // manual: item.manualFlag === 'Y' ? true : false,
            component: item.component,
            child: item.child,
            meta: {
              editable: true,
              manual: item.manualFlag === 'Y' ? true : false,
              title: item.title,
            }
          })
        }
      })
      state.routers = viewRouters
    },
    SET_ROUTERS: (state) => {
      state.addRouters = asyncRouterMap
    },
  },
  actions: {
    GenerateRoutes({
      commit
    }) {
      commit('SET_VIEW_MENU');
      commit('SET_ROUTERS');
    }
  }
}

export default permission
